import { render, staticRenderFns } from "./ArmageddonModal.vue?vue&type=template&id=435c0fa2&"
import script from "./ArmageddonModal.vue?vue&type=script&lang=js&"
export * from "./ArmageddonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports